import { App } from "@capacitor/app";
/**
 * Wrapper around Capacitor plugin app
 * https://capacitorjs.com/docs/v2/apis/app#example
 */
export class MobileApp {
  /**
   * Returns the Capacitor plugin instance
   * @readonly
   * @static
   */
  static get plugin() {
    return App;
  }
}
